import axios, { AxiosResponse } from 'axios';
import { AutoCompletionsData, RateLimitError } from 'utils/helpers/chatbotHelpers';

export const getCompassAutoCompletions = async (prompt = ''): Promise<AutoCompletionsData> => {
  try {
    const response: AxiosResponse<AutoCompletionsData> = await axios.get('/api/getAutoCompletions', {
      params: { prompt }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 429) {
      throw new RateLimitError('Too many requests, Please try again later.');
    }
    console.error('Failed to fetch autocomplete suggestions:', error);
    throw error;
  }
};